import { z } from 'zod';

// Pimcore's ResourceType or ResourceTypeGroup
export const ResourceTypeSchema = z
    .object({
        id: z.string(),
    })
    .describe('ResourceTypeSchema');

// Pimcore's Brand
export const BrandSchema = z
    .object({
        id: z.string(),
    })
    .describe('BrandSchema');

// Pimcore's ProductGroup
export const ProductGroupSchema = z
    .object({
        id: z.string(),
    })
    .describe('ProductGroupSchema');

// Pimcore's ProductApplicationSegment and ProductApplication
export const ProductApplicationSchema = z
    .object({
        id: z.string(),
    })
    .describe('ProductApplicationSchema');

// Pimcore's NavigationNode
export const NavigationNodeSchema = z
    .object({
        id: z.string(),
    })
    .describe('NavigationNodeSchema');

export const BaseResourceLibraryItemSchema = z
    .object({
        id: z.string(),
        key: z.string(),
        name: z.string(),
        description: z.string().nullable(),
        resourceType: ResourceTypeSchema,
        brand: BrandSchema.nullable(),
        productGroup: z.array(ProductGroupSchema).nullable(),
        productApplication: z.array(ProductApplicationSchema).nullable(),
        navigationScope: z.array(NavigationNodeSchema).nullable(),
        exclusiveNavigationScope: z.array(NavigationNodeSchema).nullable(),
        thumbnailUrl: z.string().nullable(),
        publicationDate: z.string().nullable(),
    })
    .describe('BaseResourceLibraryItemSchema');
